import React from 'react'

import { QA_INBOX } from '@/reducers/tasks/tasks.constants'
import { InboxRedirect } from '@/components/inbox/InboxRedirect'

export const QACopilotInbox = () => {
  return <InboxRedirect inboxType={QA_INBOX} title="Balto Quality" />
}
